export default "__VITE_ASSET__DiPM8m01__"